import { createStore } from 'vuex'
export default createStore({
    state () {
        return {
            selectedOrganizations: [],
            selectedApplications: [],
            appsToMerge: [],
            allProvinces: [
                'BC',
                'ON'
            ],
            allStates: [
                'AK',
                'AR',
                'AL',
                'AZ',
                'CA',
                'CO',
                'CT',
                'DC',
                'DE',
                'FL',
                'GA',
                'IA',
                'ID',
                'IL',
                'IN',
                'KS',
                'KY',
                'LA',
                'MA',
                'MD',
                'ME',
                'MI',
                'MN',
                'MO',
                'NC',
                'NE',
                'NH',
                'NJ',
                'NM',
                'NV',
                'NY',
                'OH',
                'OK',
                'OR',
                'PA',
                'RI',
                'SC',
                'TN',
                'TX',
                'UT',
                'VA',
                'VT',
                'WA',
                'WI',
                'WV',
                'WY'
            ]
        }
    },
    mutations: {
        setSelectedOrganizations(state, data) {
            state.selectedOrganizations = data
            sessionStorage.setItem('store', JSON.stringify(state))
        },
        setSelectedApplications(state, data) {
            state.selectedApplications = data
            sessionStorage.setItem('store', JSON.stringify(state))
        },
        setAppsToMerge(state, data) {
            state.appsToMerge = data
            sessionStorage.setItem('store', JSON.stringify(state))
        },
        removeSelectedApplications(state, data) {
            for (var i = 0; i < data.length; i++) {
                state.selectedApplications.splice(state.selectedApplications.indexOf(data[i]), 1)
            }
            sessionStorage.setItem('store', JSON.stringify(state))
        }
    }
});
